// extracted by mini-css-extract-plugin
export default {"uniqText5":"uniq-text_uniqText5__XVDzD","glow":"uniq-text_glow__SQ6Ut","uniqMarqueeText":"uniq-text_uniqMarqueeText__TzH4U","letter-glow":"uniq-text_letter-glow__fyD7t"};